import script from "./report-element-details-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./report-element-details-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__